import { useAppSelector } from '@hooks/redux'
import { Anchor, Group, ThemeIcon, Title, Tooltip } from '@mantine/core'
import {
  selectActiveSection,
  selectBackLink,
  selectHeaderInfo,
} from '@redux/site/siteSlice'
import {
  IconCaretLeft,
  IconChevronLeft,
  IconInfoCircleFilled,
} from '@tabler/icons-react'

export const SettingsShellHeader = () => {
  const backLink = useAppSelector(selectBackLink)
  const activeSection = useAppSelector(selectActiveSection)
  const info = useAppSelector(selectHeaderInfo)

  return (
    <Group
      h="100%"
      px="md"
      align="center"
      justify="space-between"
      wrap="nowrap"
    >
      <Group align="center" wrap="nowrap">
        {activeSection.length > 0 && !backLink && (
          <>
            {info ? (
              <Group gap={5} align="center">
                <Title order={3}>{activeSection}</Title>
                <Tooltip label={info} position="bottom-start">
                  <ThemeIcon mt={3} variant="transparent" color="gray.5">
                    <IconInfoCircleFilled size={18} />
                  </ThemeIcon>
                </Tooltip>
              </Group>
            ) : (
              <Title order={3}>{activeSection}</Title>
            )}
          </>
        )}
        {backLink && (
          <Group gap={3}>
            <ThemeIcon variant="transparent">
              <IconChevronLeft size={18} />
            </ThemeIcon>
            <Anchor href={backLink.href}>Back to {backLink.title}</Anchor>
          </Group>
        )}
      </Group>
    </Group>
  )
}
